// The reply box's English view (2026-10-30, docs/agent-draft-shadow.md
// "Fitment before a purchase", Part 5.3). When the reply in the box is not
// English, the panel shows it in English for review on every channel, and
// says which language is being sent. The box's text is what is sent; the
// English view is only for reading. Pure helpers; the panel calls
// POST /api/conversations/:id/draft-translation, debounced.

const FOREIGN_WORDS = /\b(?:el|la|los|las|de|que|y|en|su|sus|para|con|por|una|uno|es|est[aá]|son|pieza|piezas|veh[ií]culo|gracias|hola|le|les|se|del|al|nous|vous|pour|avec|une|der|das|und|ist|nicht|n[aã]o|voc[eê])\b/gi
const PROTECT = /\[[A-Z0-9_]+\]|https?:\/\/\S+|\bINSERT[A-Z0-9_]+\b|\S*\d\S*/g

// Whether the text may be in another language: a letter outside ASCII
// (an accent, another script), or at least two common words of Spanish,
// French, German or Portuguese. English text with none of that is never
// sent to the translator. HTML tags are ignored.
export function mayBeForeign(text) {
  const t = String(text ?? '').replace(/<[^>]+>/g, ' ').replace(PROTECT, ' ')
  if (!t.trim()) return false
  if (/[^\x00-\x7F]/.test((t.match(/\p{L}/gu) ?? []).join(''))) return true
  return (t.match(FOREIGN_WORDS) ?? []).length >= 2
}

// The caption above the English view: "Sending in Spanish; English shown for
// review". null without a language other than English.
export function sendingCaption(language) {
  const l = String(language ?? '').trim()
  if (!l || /^english$/i.test(l)) return null
  return `Sending in ${l}; English shown for review`
}

export const DRAFT_TRANSLATION_DEBOUNCE_MS = 1200
